
import Vue from 'vue';
import VueRouter from 'vue-router';
import { getBaseUrl } from "@/uilt/new-axios";



Vue.use(VueRouter); 
const currUrl = getBaseUrl(window.location.href)
console.log('currUrl', currUrl)

const routes = [
  {
    path: '/login',
    name: 'login',
    // component: () => currUrl != 'http://localhost:9001/login' ? import('../views/login.vue') : import('../views/loginIDaaS.vue'),
    component: () => import('../views/login.vue'),
  },
  {
    path: '/loginIDaaS',
    name: 'LoginIDaaS',
    component: () => import('../views/loginIDaaS.vue'),
  },
  {
    path: '/LoginAccess',
    name: 'Login',
    component: () => import('../views/loginAccess.vue'),
  },
  {
    path: '/homePage',
    name: 'homePage',
    component: () => import('../views/homePage/homePage.vue'),
  },
  {
    path: '/SZ_homePageReportNew',
    name: 'SZ_homePageReportNew',
    component: () => import('../views/homePage/SZ_homePageReportNew.vue'),
  },
  {
    path: '/userAgree',
    name: 'userAgree',
    component: () => import('../views/userAgree.vue'),
  },
  {
    path: '/userPrivate',
    name: 'userPrivate',
    component: () => import('../views/userPrivate.vue'),
  },
  {
    path: '/previewPage',
    name: 'previewPage',
    component: () => import('../views/previewPage.vue'),
  },
  {
    path: '/messageManagementList',
    name: 'messageManagement',
    component: () => import('../views/messageManagement/messageManagementList.vue'),
  },
];

export default routes;
